module.exports = __webpack_public_path__ + "img/tips6.811e6693.png";